<script>
  import { ignore } from '../../../Common/tools';
  import { onMount } from 'svelte';
  import WebComponents from '../../../main.js';
  import { M } from '../../../external.js';
  import { External } from '../../../external';

  export let label;
  export let data;
  export let valid;
  export let onChange = ignore;

  let result = {
    videoId: null
  };

  let currentVideo = null;

  const onSelectVideo = () => {
    WebComponents.VideoService.videoPicker((videoObject) => {
      if (!videoObject) {
        return;
      }
      result.videoId = videoObject.id;

      currentVideo = videoObject;

      onResultChange();
    });
  };

  const onResultChange = () => {
    if (result.videoId) {
      data.settings = [];
      data.settings.push({
        key: '0',
        value: JSON.stringify(result)
      });

      data.name = `"${currentVideo.title}"`;
      valid = true;
      onChange();
    } else {
      valid = false;
    }
  };

  const fetchSelectedVideo = async () => {
    if (result.videoId) {
      currentVideo = await WebComponents.VideoService.getVideoMetadataById(result.videoId);
    }
  };

  onMount(async () => {
    if (!data.settings) {
      data.settings = [];
    }
    if (data.settings.length > 0) {
      result = JSON.parse(data.settings[0].value);
      await fetchSelectedVideo();
    }
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{M.VIDEO}</h4>
  <div class="popup-input-wrapper f-left mt-15">
    {#if currentVideo}
      <div on:click={onSelectVideo} class="col20 f-left ui-sorable form-admin-style-2 video-sortable-item mb-0">
        <div class="col20 f-left">
          <div class="form-step-wrapper flex align-center">
            <div class="flex align-center flex-1 video-arrange-wrapper">
              <div class="crm-folder-thumb-outer">
                <span
                  class="crm-folder-thumb"
                  style="background-image: url({External.getThumbnailsFromBase(
                    currentVideo.thumbnailFileBase,
                    '640x480'
                  ) +
                    currentVideo.thumbnailFileName +
                    '?format=webp'});"></span>
              </div>
              <div class="col20 f-left">
                <span
                  class="step-name ml-15 col20-important f-left added-video-edit-properties"
                  style="cursor: pointer;">{currentVideo.title}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    {:else}
      <div class="col20 f-left t-center">
        <a class="middle-button blue f-none inline-block" on:click={onSelectVideo}>{M.SELECT_VIDEO}</a>
      </div>
    {/if}
  </div>
</div>
